import React from "react";
import { View, Text, StyleSheet, FlatList } from "react-native";
import { COLORS } from "@dehaat/dds";
import { SoilNutrient } from "../models/advistory";

type Props = {
  data: SoilNutrient[];
};

const NutrientSummary: React.FC<Props> = ({ data }) => {
  const renderItem = ({ item }: { item: SoilNutrient }) => {
    return (
      <View style={styles.card}>
        <Text style={styles.title}>{item.name}</Text>
        <Text style={[styles.status, { color: item.color }]}>
          {item.amount}
        </Text>
      </View>
    );
  };

  return (
    <View>
      <FlatList
        data={data}
        renderItem={renderItem}
        keyExtractor={(item, index) => `${item.name}-${index}`}
        numColumns={2}
        columnWrapperStyle={styles.row}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    justifyContent: "space-between",
    marginBottom: 12,
  },
  card: {
    backgroundColor: COLORS.neutral10,
    borderRadius: 12,
    paddingVertical: 16,
    paddingHorizontal: 12,
    width: "48%",
    alignItems: "center",
  },
  title: {
    fontSize: 15,
    fontWeight: "600",
    color: "#111",
    marginBottom: 8,
    textAlign: "center",
  },
  status: {
    fontSize: 14,
    fontWeight: "500",
    marginTop: 8,
  },
  buttonWrapper: {
    marginTop: 8,
    paddingHorizontal: 12,
  },
});

export default NutrientSummary;
